module.exports = __webpack_public_path__ + "img/restrooms.73405427.svg";